import { render, staticRenderFns } from "./BalanceMoneyStep2.vue?vue&type=template&id=69bd83eb&scoped=true"
import script from "./BalanceMoneyStep2.vue?vue&type=script&lang=js"
export * from "./BalanceMoneyStep2.vue?vue&type=script&lang=js"
import style0 from "./BalanceMoneyStep2.vue?vue&type=style&index=0&id=69bd83eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bd83eb",
  null
  
)

export default component.exports